import sachsenVolunteerCard from '~/lang/de/fsExtension/sachsenVolunteerCard.js'
import bayernVolunteerCard from "./bayernVolunteerCard";

export default {
    sachsenVolunteerCard,
    bayernVolunteerCard,
}
